import React, { useState, useEffect, useCallback } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import './ScannerProfileView.css';

function ScannerProfileView({ scannerData, schoolName, onLogout }) {
  const [totalScans, setTotalScans] = useState(0);
  const [scansToday, setScansToday] = useState(0);
  const [loadingStats, setLoadingStats] = useState(true);

  const loadStats = useCallback(async () => {
    if (!scannerData?.uid) {
      setLoadingStats(false);
      return;
    }
    try {
      setLoadingStats(true);
      const q = query(
        collection(db, 'studentActivityLogs'),
        where('scannerId', '==', scannerData.uid)
      );
      const snapshot = await getDocs(q);
      let total = 0;
      let today = 0;
      const startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      const startMs = startOfToday.getTime();

      snapshot.forEach((d) => {
        const data = d.data();
        total += 1;
        const ts = data.timestamp;
        let ms = null;
        if (ts && typeof ts.toMillis === 'function') {
          ms = ts.toMillis();
        } else if (ts && ts.seconds) {
          ms = ts.seconds * 1000;
        } else if (ts instanceof Date) {
          ms = ts.getTime();
        }
        if (ms != null && ms >= startMs) {
          today += 1;
        }
      });

      setTotalScans(total);
      setScansToday(today);
    } catch (error) {
      console.error('Error loading scanner stats:', error);
    } finally {
      setLoadingStats(false);
    }
  }, [scannerData?.uid]);

  useEffect(() => {
    loadStats();
  }, [loadStats]);

  return (
    <div className="scanner-profile-view">
      <h2>Profile</h2>

      <div className="profile-section">
        <div className="profile-header">
          <div className="profile-photo">
            <div className="placeholder-photo">👤</div>
          </div>
          <div className="profile-name-section">
            <h3>{scannerData?.displayName || 'Scanner'}</h3>
            <p>Scanner</p>
          </div>
        </div>

        <div className="profile-info">
          <div className="profile-field">
            <label>Name</label>
            <p>{scannerData?.displayName || '—'}</p>
          </div>
          <div className="profile-field">
            <label>Email</label>
            <p>{scannerData?.email || '—'}</p>
          </div>
          <div className="profile-field">
            <label>School</label>
            <p>{schoolName || (scannerData?.schoolId ? scannerData.schoolId : '—')}</p>
          </div>
          <div className="profile-field">
            <label>Role</label>
            <p>Scanner</p>
          </div>
        </div>
      </div>

      <div className="stats-section">
        <h3>Scan Statistics</h3>
        {loadingStats ? (
          <p className="stats-loading">Loading statistics...</p>
        ) : (
          <div className="stats-grid">
            <div className="stat-card">
              <span className="stat-icon">📊</span>
              <div className="stat-info">
                <h3>{totalScans}</h3>
                <p>Total Scans</p>
              </div>
            </div>
            <div className="stat-card">
              <span className="stat-icon">📅</span>
              <div className="stat-info">
                <h3>{scansToday}</h3>
                <p>Scans Today</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <button className="profile-logout-button" onClick={onLogout}>
        Logout
      </button>
    </div>
  );
}

export default ScannerProfileView;
